// Shared by the animated diagram and the article Markdown, which lists the same steps.
export interface Caption {
  end: number
  focus: "push" | "indexer" | "strip" | "chunk" | "embed" | "retry" | "land" | null
  label: string
  text: string
}

export const embedDuration = 14
export const failureDuration = 19.5

export const embedCaptions: Caption[] = [
  {
    end: 2.5,
    focus: "push",
    label: "01 / push",
    text: "One event enters the pipeline the moment the branch moves.",
  },
  {
    end: 3.7,
    focus: "indexer",
    label: "02 / indexer",
    text: "Commits, pull requests, and checkpoints become separate documents.",
  },
  {
    end: 6.9,
    focus: "strip",
    label: "03 / strip",
    text: "Only the conversation moves forward. Scaffolding is removed.",
  },
  {
    end: 8.4,
    focus: "chunk",
    label: "04 / chunk",
    text: "Prose becomes passages of approximately 700 tokens.",
  },
  {
    end: 9.8,
    focus: "embed",
    label: "05 / embed",
    text: "Each passage becomes a vector in the repository namespace.",
  },
  {
    end: 12,
    focus: "land",
    label: "06 / land",
    text: "Code is queryable in seconds. The conversation follows later.",
  },
  {
    end: embedDuration,
    focus: null,
    label: "done",
    text: "One push has two arrival times and no manual reindexing.",
  },
]

export const failureCaptions: Caption[] = [
  {
    end: 2.5,
    focus: "push",
    label: "01 / push",
    text: "The same event enters the pipeline with a downstream failure.",
  },
  {
    end: 3.7,
    focus: "indexer",
    label: "02 / indexer",
    text: "Commits, pull requests, and checkpoints become separate documents.",
  },
  {
    end: 6.9,
    focus: "strip",
    label: "03 / strip",
    text: "Only the conversation moves forward. Scaffolding is removed.",
  },
  {
    end: 8.4,
    focus: "chunk",
    label: "04 / chunk",
    text: "Prose becomes passages of approximately 700 tokens.",
  },
  {
    end: 9.7,
    focus: "embed",
    label: "05 / embed fails",
    text: "A provider rate limit rejects the write. It is not dropped.",
  },
  {
    end: 12.6,
    focus: "retry",
    label: "06 / retry lane",
    text: "The event waits for redelivery with exponential backoff.",
  },
  {
    end: 14.7,
    focus: "embed",
    label: "07 / redeliver",
    text: "The second attempt succeeds and the write continues.",
  },
  {
    end: 16.9,
    focus: "land",
    label: "08 / land",
    text: "The chunks arrive in the same place as the first attempt.",
  },
  {
    end: failureDuration,
    focus: null,
    label: "done",
    text: "Delivery is at least once from end to end.",
  },
]
